import ZoomChat from './ZoomChat';

export default ZoomChat;
